import { GiftCardLeftPanelSide } from 'app/src/features/Shopping/Direct/Giftcard/components/GiftCardLeftPanelSide'
import { GiftCardRightPanelSide } from 'app/src/features/Shopping/Direct/Giftcard/components/GiftCardRightPanelSide'
import { GiftCardWidget } from 'app/src/features/Shopping/Direct/Giftcard/components/GiftCardWidget'
import { shoppingApi } from 'app/src/services/welfareportal'
import {
  CatalogSummaryButtonInformativeDialog,
  CheckCatalogButton,
  ErrorCancelPage,
  PortalConfirmDialog,
} from 'app/src/shared/components'
import { CancelSuccess } from 'app/src/shared/components/CancelSuccess'
import { Button } from 'primereact/button'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function GiftCardDetails(props: { order: shoppingApi.OrderDetails; funnelMode?: boolean }) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.GiftCard' })
  const [showUsageModal, setShowUsageModal] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [errorComponentVisible, setErrorComponentVisible] = useState(false)
  const [successComponentVisible, setSuccessComponentVisible] = useState(false)
  const deleteOrder = shoppingApi.useOrderCancel()

  const orderDetailGiftCard = props.order?.purchaseDetails as shoppingApi.OrderDetailsPurchaseGiftCard
  const handleOrderCancellation = async () => {
    try {
      await deleteOrder.mutateAsync({
        pathParams: { orderId: props.order.orderId },
      })
      setShowModal(false)
      setSuccessComponentVisible(true)
    } catch (error) {
      setErrorComponentVisible(true)
      console.error('Failed to cancel order:', error)
    }
  }
  if (errorComponentVisible) {
    return (
      <ErrorCancelPage
        errorTitle={t('cancelOrder.cancelErrorMessage.title')}
        errorSubtitle={t('cancelOrder.cancelErrorMessage.subtitle')}
      >
        <div className='mx-auto flex justify-center'>
          <CheckCatalogButton />
        </div>
      </ErrorCancelPage>
    )
  }
  if (successComponentVisible) {
    return (
      <CancelSuccess
        successTitle={t('cancelOrder.cancelSuccessMessage.title')}
        successSubTitle={t('cancelOrder.cancelSuccessMessage.subtitle')}
      >
        <div className='mx-auto flex justify-center'>
          <CheckCatalogButton />
        </div>
      </CancelSuccess>
    )
  }
  if (deleteOrder.isPending)
    return (
      <ProgressSpinner
        data-testid='loading-element'
        pt={{
          root: {
            className: 'w-[50px] h-[50px]',
          },
        }}
      />
    )
  return (
    <div className='mx-auto max-w-5xl'>
      {(typeof props.funnelMode === 'undefined' || !props.funnelMode) && (
        <div className='noPrint'>
          <h1 className='welfareportal-titlecenter'>{t('detailPageTitle')}</h1>
          {props.order?.isCancelable && props.order.status !== 'canceled' && (
            <div className='flex justify-end'>
              <Button link onClick={() => setShowModal(true)} icon='pi pi-trash' label={t('cancelOrder.cancelButtonLabel')} />
            </div>
          )}
          <div className='card grid grid-cols-1 divide-x-0 divide-y-2 p-5 lg:grid-cols-12 lg:divide-x-2 lg:divide-y-0'>
            <GiftCardLeftPanelSide
              statusMode
              order={props.order}
              setShowUsageModal={setShowUsageModal}
              showUsageModal={showUsageModal}
            />
            <GiftCardRightPanelSide order={props.order} />
          </div>
        </div>
      )}
      <GiftCardWidget order={props.order} />
      {props.order?.status === 'canceled' ? (
        <></>
      ) : orderDetailGiftCard?.cardActivationUrl ? (
        <>
          <div className='flex justify-center'>
            {t('cardToActivate.informativeBanner') && (
              <>
                <div dangerouslySetInnerHTML={{ __html: t('cardToActivate.informativeBanner') }}></div>
                <div className='ml-1 pt-[5px]'>
                  <CatalogSummaryButtonInformativeDialog
                    setShowModal={setShowUsageModal}
                    showModal={showUsageModal}
                    bannerId='GIFTCARDUSAGE'
                    pt={{
                      buttonLabel: t('cardToActivate.usageButtonLabel'),
                    }}
                  />
                </div>
              </>
            )}
          </div>
          {typeof props.funnelMode !== 'undefined' && props.funnelMode ? (
            <>
              {t('cardToActivate.activationDescriptionFunnelMode') && (
                <div dangerouslySetInnerHTML={{ __html: t('cardToActivate.activationDescriptionFunnelMode') }}></div>
              )}
            </>
          ) : (
            <>
              {t('cardToActivate.activationDescriptionDetailsMode') && (
                <div dangerouslySetInnerHTML={{ __html: t('cardToActivate.activationDescriptionDetailsMode') }}></div>
              )}
            </>
          )}
        </>
      ) : (
        <div>
          {t('cardActive.informativeBanner') && <div dangerouslySetInnerHTML={{ __html: t('cardActive.informativeBanner') }} />}
          {!orderDetailGiftCard?.cardDetailsUrl && (
            <div className='mt-4 flex justify-center'>
              <Button
                role='link'
                rounded
                outlined
                onClick={() => window.print()}
                link={typeof props.funnelMode === 'undefined' || !props.funnelMode}
                text={typeof props.funnelMode === 'undefined' || !props.funnelMode}
                pt={{
                  root: { className: typeof props.funnelMode === 'undefined' || !props.funnelMode ? 'underline' : undefined },
                }}
              >
                {t('getYourCodeButtonLabel')}
              </Button>
            </div>
          )}
          {t('cardActive.informativeBannerFunnelMode') && (
            <div dangerouslySetInnerHTML={{ __html: t('cardActive.informativeBannerFunnelMode') }} />
          )}
        </div>
      )}
      <div className='mx-auto flex justify-center'>
        <CheckCatalogButton />
      </div>
      {showModal && (
        <PortalConfirmDialog
          body={t('cancelOrder.body')}
          title={t('cancelOrder.title')}
          reject={() => setShowModal(false)}
          accept={handleOrderCancellation}
        />
      )}
    </div>
  )
}
